<template>
  <header class="header">
    <div class="header__left">
      <burger
        :is-open-sidebar="isOpenSidebar"
        @toggle-sidebar="$emit('toggle-sidebar')"
      />

      <div class="shop-title">
        <router-link to="/">Master CRM</router-link>
        <span class="shop-name">&nbsp;-&nbsp;{{ activeShopName }}</span>
        <span class="page-name">&nbsp;|&nbsp;{{ getPageTitle }}</span>
      </div>
    </div>

    <div class="header___right">
      <button
        v-if="getIsOffline"
        class="health-check margin-right-15"
        @click="healthCheck"
      >
        Проверка доступности сервера
      </button>

      <button
        class="logout"
        @click="logoutWrapper"
      >
        Выход
      </button>
    </div>
  </header>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import page from '@/mixins/page'

import Burger from './components/burger'

import { LIST_SHOPS } from '@/constants/global'
import { parseCookies } from '@/helper'

export default {
  name: 'MainHeader',
  mixins: [page],
  components: {
    Burger
  },
  props: {
    isOpenSidebar: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      activeShopName: ''
    }
  },
  computed: {
    ...mapGetters('user', ['getData']),
    ...mapGetters('config', ['getIsOffline'])
  },
  watch: {
    getData: {
      immediate: true,
      async handler () {
        this.setShopName()
      }
    }
  },
  methods: {
    ...mapActions('user', ['logout']),
    ...mapActions('config', ['healthCheck']),
    setShopName () {
      const shopId = parseCookies()?.shopId || ''

      this.activeShopName = LIST_SHOPS.find(({ id }) => id === shopId)?.name
    },
    async logoutWrapper () {
      if (this.loading) {
        return
      }

      this.$bus.emit('start-loader')
      this.loading = true

      const { error } = await this.logout()

      if (error) {
        this.$notify({
          type: 'error',
          title: 'Ошибка при выходе из аккаунта!',
          text: error.message,
          clean: false,
          duration: 3000
        })
      }

      await this.$router.push('/auth')

      this.$bus.emit('stop-loader')
      this.loading = false
    }
  }
}
</script>

<style lang="scss" src="./style.scss" />
